export const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&family=Noto+Sans+Devanagari:wght@400;500;600;700&display=swap');
  *,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
  html,body,#root{height:100%;}
  body{-webkit-font-smoothing:antialiased;-webkit-text-size-adjust:100%;}

  /* ── Safe area support for notch/gesture-nav Android phones ── */
  html{padding:env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left);}
  .safe-bottom{padding-bottom:max(env(safe-area-inset-bottom), 16px) !important;}
  .safe-top{padding-top:max(env(safe-area-inset-top), 12px) !important;}
  ::-webkit-scrollbar{width:4px;}
  ::-webkit-scrollbar-thumb{background:#e2e8f0;border-radius:4px;}
  textarea,input,select{outline:none;font-size:16px;}
  button:focus-visible,a:focus-visible,[role="button"]:focus-visible{outline:2px solid #0d9488;outline-offset:2px;border-radius:8px;}
  input:focus-visible,textarea:focus-visible,select:focus-visible{outline:2px solid #0d9488;outline-offset:0;}

  /* ── Existing animations ── */
  @keyframes fadeUp{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:translateY(0)}}
  @keyframes logoIn{from{opacity:0;transform:scale(0.6)}to{opacity:1;transform:scale(1)}}
  @keyframes fadeIn{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:translateY(0)}}
  @keyframes pulse{0%,100%{box-shadow:0 0 0 0 rgba(13,148,136,0.4)}50%{box-shadow:0 0 0 20px rgba(13,148,136,0)}}
  @keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-8px)}}
  @keyframes su{from{transform:translateY(100%)}to{transform:translateY(0)}}
  @keyframes td{0%,80%,100%{transform:scale(.6);opacity:.3}40%{transform:scale(1);opacity:1}}
  @keyframes showSa{0%{opacity:0;transform:scale(0.8)}20%{opacity:1;transform:scale(1)}60%{opacity:1;transform:scale(1)}85%{opacity:0;transform:scale(1.05)}100%{opacity:0}}
  @keyframes showS{0%{opacity:0}60%{opacity:0;transform:scale(0.85)}85%{opacity:1;transform:scale(1)}100%{opacity:1;transform:scale(1)}}
  @keyframes slideInLeft{from{transform:translateX(-100%)}to{transform:translateX(0)}}

  /* ── Premium polish: staggered entrance ── */
  @keyframes springUp{from{opacity:0;transform:translateY(18px) scale(0.97)}to{opacity:1;transform:translateY(0) scale(1)}}
  @keyframes scaleIn{from{opacity:0;transform:scale(0.92)}to{opacity:1;transform:scale(1)}}
  @keyframes counterPop{0%{transform:scale(1)}50%{transform:scale(1.18)}100%{transform:scale(1)}}
  @keyframes slideDown{from{opacity:0;transform:translateY(-10px)}to{opacity:1;transform:translateY(0)}}
  @keyframes shimmer{0%{background-position:-200px 0}100%{background-position:200px 0}}

  /* ── Scale-on-tap: any tappable card ── */
  .tap-scale{transition:transform 0.18s cubic-bezier(0.34,1.56,0.64,1);}
  .tap-scale:active{transform:scale(0.97) !important;}

  /* ── 3D tactile button (Duolingo-style press) ── */
  .btn-tactile{border-bottom:3px solid rgba(0,0,0,0.12);transition:all 0.1s ease;-webkit-tap-highlight-color:transparent;}
  .btn-tactile:active{border-bottom-width:0;transform:translateY(3px);}

  /* ── Secondary tactile (text links, pills) ── */
  .btn-secondary-tactile{transition:opacity 0.1s ease,transform 0.1s ease;cursor:pointer;-webkit-tap-highlight-color:transparent;}
  .btn-secondary-tactile:active{opacity:0.7;transform:scale(0.97);}

  /* ── Tactile card (replaces onMouseOver/Out hover-only feedback) ── */
  .card-tactile{transition:transform 0.12s cubic-bezier(0.25,0.46,0.45,0.94),box-shadow 0.12s ease;cursor:pointer;-webkit-tap-highlight-color:transparent;}
  .card-tactile:active{transform:scale(0.97);box-shadow:0 1px 4px rgba(140,110,60,0.08);}

  /* ── Touch target enforcer (44px minimum) ── */
  .touch-target{min-height:44px;min-width:44px;display:inline-flex;align-items:center;justify-content:center;cursor:pointer;-webkit-tap-highlight-color:transparent;}

  /* ── Gold coin shimmer for zero state ── */
  @keyframes coinShimmer{0%,100%{opacity:0.7;filter:brightness(1)}50%{opacity:1;filter:brightness(1.2)}}

  /* ── Celebration animations ── */
  @keyframes wrongShake{0%,100%{transform:translateX(0)}10%,50%,90%{transform:translateX(-4px)}30%,70%{transform:translateX(4px)}}
  @keyframes correctPulse{0%{box-shadow:0 0 0 0 rgba(26,122,82,0.4)}50%{box-shadow:0 0 0 12px rgba(26,122,82,0)}100%{box-shadow:0 0 0 0 rgba(26,122,82,0)}}
  @keyframes wrongPulse{0%{box-shadow:0 0 0 0 rgba(232,93,58,0.4)}50%{box-shadow:0 0 0 12px rgba(232,93,58,0)}100%{box-shadow:0 0 0 0 rgba(232,93,58,0)}}
  @keyframes ringFill{from{stroke-dashoffset:var(--circ)}to{stroke-dashoffset:0}}
  @keyframes popIn{0%{transform:scale(0);opacity:0}60%{transform:scale(1.15)}100%{transform:scale(1);opacity:1}}
  @keyframes celebrateBounce{0%,100%{transform:translateY(0)}50%{transform:translateY(-12px)}}

  /* Utility classes for MCQ feedback */
  .mcq-correct{animation:correctPulse 0.6s ease-out;background:#E8F5EE !important;border-color:#1A7A52 !important;color:#1A7A52 !important;}
  .mcq-wrong{animation:wrongShake 0.4s ease-out, wrongPulse 0.6s ease-out;background:#FEF2F2 !important;border-color:#E85D3A !important;color:#B91C1C !important;}

  /* ── Spring easing tokens (used via inline animation) ── */
  .anim-spring{animation-timing-function:cubic-bezier(0.16,1,0.3,1);}

  /* ── Skeleton loader shimmer ── */
  .skeleton{background:linear-gradient(90deg,#e8f0ec 25%,#d4e0da 50%,#e8f0ec 75%);background-size:400px 100%;animation:shimmer 1.5s ease-in-out infinite;border-radius:8px;}

  /* ── Backdrop blur for sticky headers ── */
  .blur-header{backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);}

  /* Sidebar responsive */
  .desktop-sidebar{display:flex !important;}
  .hamburger{display:none !important;}
  @media(max-width:768px){
    .desktop-sidebar{display:none !important;}
    .hamburger{display:flex !important;}
  }
  .problem-img-wrap{min-width:80px;}
  .problem-img{width:80px !important;height:80px !important;}
  @media(min-width:601px){
    .problem-img-wrap{min-width:160px;}
    .problem-img{width:160px !important;height:120px !important;}
  }
  @media(max-width:600px){
    .nav-bar{padding:12px 16px !important;}
    .hero-section{padding:32px 16px 20px !important;flex-direction:column !important;}
    .how-grid{grid-template-columns:1fr 1fr !important;}
    .feat-grid{grid-template-columns:1fr 1fr !important;}

    /* Profile page — collapse dark panel to top strip */
    .profile-card{border-radius:16px !important;}
    .profile-panel{flex-direction:column !important;padding:20px 20px 16px !important;}
    .profile-bullets{flex-direction:row !important;flex-wrap:wrap !important;gap:8px !important;margin-top:8px !important;}
    .profile-card > div:last-child{padding:20px 20px 24px !important;}
    .profile-grid{grid-template-columns:1fr 1fr !important;}

    /* Tutor app */
    .tutor-topbar{padding:10px 12px !important;}
    .problem-banner{padding:8px 12px !important;}
    .problem-banner span{font-size:12px !important;}
    .chat-area{padding:12px 10px !important;}
    .chat-bubble > div{font-size:14px !important;padding:10px 13px !important;}
    .hints-row{padding:0 10px 8px !important;gap:6px !important;}
    .hints-row button{font-size:12px !important;padding:5px 10px !important;}
    .input-bar{padding:8px 10px 18px !important;}
    .home-card{padding:24px 16px !important;border-radius:20px !important;}
    .home-card textarea{font-size:14px !important;}

    /* Modals */
    .revision-panel{padding:16px 16px 36px !important;}
    .photo-panel{padding:16px 16px 36px !important;}
  }

  /* ── Very small phones: 375px and below ── */
  @media(max-width:375px){
    .how-grid{grid-template-columns:1fr !important;}
    .feat-grid{grid-template-columns:1fr !important;}
    .profile-grid{grid-template-columns:1fr !important;}
    .tutor-topbar .badge{display:none !important;}
  }

  /* Splash illustration responsive */
  .splash-illustration{
    position:absolute;bottom:0;right:0;
    height:70%;max-height:80vh;
    object-fit:contain;object-position:bottom right;
    pointer-events:none;z-index:0;
    mix-blend-mode:screen;
    -webkit-mask-image:linear-gradient(to right, transparent 0%, black 40%, black 100%), linear-gradient(to top, black 0%, black 70%, transparent 100%);
    -webkit-mask-composite:destination-in;
    mask-image:linear-gradient(to right, transparent 0%, black 40%, black 100%), linear-gradient(to top, black 0%, black 70%, transparent 100%);
    mask-composite:intersect;
  }
  @media(max-width:768px){
    .splash-illustration{
      height:40% !important;
      right:50% !important;
      transform:translateX(50%) !important;
      object-position:bottom center !important;
      opacity:0.2 !important;
      -webkit-mask-image:radial-gradient(ellipse at center bottom, black 30%, transparent 70%) !important;
      mask-image:radial-gradient(ellipse at center bottom, black 30%, transparent 70%) !important;
    }
  }
`;
